import React, { Component } from 'react'
import { observer } from 'mobx-react'

import {
    Table
} from 'react-bootstrap'

@observer(['agreements', 'invoices', 'quickbooks', 'globals'])
export default class invoiceDetail extends Component {

    constructor(props) {
        super(props)

        let token = this.props.token

        if (!this.props.invoices.invoiceDetail.id) {
            this.getInvoiceData(token)
        }
    }

    getInvoiceData(token) {
        this.props.invoices.loadInvoiceByToken(token, this.props.emailStatus, (invoice) => {
            if (!invoice) {
                alert('We could not load this invoice. It may be missing information from Quickbooks.')
                this.props.setLoadableState(false)
                return
            }
            this.props.setLoadableState(true)
            this.props.invoices.setInvoiceViewDetails({
                agreementDetails: invoice.agreementDetails,
                paymentId: invoice.paymentId,
                invoiceId: invoice.id,
                quoteType: invoice.quoteType,
                status: invoice.status,
                userFullName: invoice.userFullName,
                userEmail: invoice.userEmail
            }, () => {
                this.props.setLoadableState(false)
            })
        })
    }

    render() {

        let hardwareList = ''
        //let subtotal = 0
        if (this.props.invoices.invoiceDetail.quoteHardware && this.props.invoices.invoiceDetail.quoteHardware.length > 0) {
            hardwareList = this.props.invoices.invoiceDetail.quoteHardware.map((hw) => {
                //subtotal += parseFloat(hw.cost) * parseFloat(hw.quantity)
                return (<tr>
                    <td>{hw.quantity}</td>
                    <td>{hw.hardwareName}</td>
                    <td>{hw.hardwareDescription}</td>
                    <td>${hw.cost.toFixed(2)}</td>
                    <td>${(hw.quantity * hw.cost).toFixed(2)}</td>
                </tr>)
            })
        }

        let noteContainer = ''

        if (this.props.invoices.invoiceDetail.note && this.props.invoices.invoiceDetail.note.length > 0) {
            noteContainer = <p className="text-muted well well-sm no-shadow small-top-margin" style={{ width: 'margin-top: 10px' }}>{this.props.invoices.invoiceDetail.note}</p>
        }

        return (
            <div className="row">
                <div className="col-md-12">
                    <div className="x_content">
                        <section className="content invoice">
                            <div className="row">
                                <div className="col-xs-12 invoice-header">
                                    <h1><i className="fa fa-globe"></i> Invoice<small className="pull-right">Date: {this.props.invoices.invoiceDetail.formattedQuoteDate}</small></h1>
                                </div>
                            </div>
                            <div className="row invoice-info">
                                <div className="col-sm-6 invoice-col">
                                    <strong>Billing Address</strong>
                                    <address>
                                        {this.props.invoices.invoiceDetail.companyName}
                                        <br />{this.props.invoices.invoiceDetail.billingAddressName}
                                        <br />{this.props.invoices.invoiceDetail.billingAddressAddress}
                                        <br />{this.props.invoices.invoiceDetail.billingAddressCity}, {this.props.invoices.invoiceDetail.billingAddressState} {this.props.invoices.invoiceDetail.billingAddressZipCode}
                                        <br />{this.props.invoices.invoiceDetail.billingAddressCountry}
                                    </address>
                                </div>
                                <div className="col-sm-6 invoice-col">
                                    <strong>Shipping Address</strong>
                                    <address>
                                        {this.props.invoices.invoiceDetail.companyName}
                                        <br />{this.props.invoices.invoiceDetail.shippingAddressName}
                                        <br />{this.props.invoices.invoiceDetail.shippingAddressAddress}
                                        <br />{this.props.invoices.invoiceDetail.shippingAddressCity}, {this.props.invoices.invoiceDetail.shippingAddressState} {this.props.invoices.invoiceDetail.shippingAddressZipCode}
                                        <br />{this.props.invoices.invoiceDetail.shippingAddressCountry}
                                    </address>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-xs-12 table">
                                    <Table className="table table-striped">
                                        <thead>
                                            <tr>
                                                <th>Qty</th>
                                                <th>Item</th>
                                                <th style={{ width: '59%' }}>Description</th>
                                                <th>Price</th>
                                                <th>Total</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {hardwareList}
                                        </tbody>
                                    </Table>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-xs-6">
                                    <p className="lead">Payment Methods:</p>
                                    <img src="/images/visa.png" alt="Visa" />
                                    <img src="/images/mastercard.png" alt="Mastercard" />
                                    <img src="/images/american-express.png" alt="American Express" />
                                    {noteContainer}
                                </div>
                                <div className="col-xs-6">
                                    <p className="lead">Amount Due</p>
                                    <div className="table-responsive">
                                        <Table className="table">
                                            <tbody>
                                                <tr>
                                                    <th style={{ width: '50%' }}>Subtotal:</th>
                                                    <td>${this.props.invoices.invoiceDetail.hardwareTotal}</td>
                                                </tr>
                                                <tr>
                                                    <th>Tax</th>
                                                    <td>${this.props.invoices.invoiceDetail.taxTotal}</td>
                                                </tr>
                                                <tr>
                                                    <th>Shipping:</th>
                                                    <td>${this.props.invoices.invoiceDetail.shippingCost}</td>
                                                </tr>
                                                <tr>
                                                    <th>Total:</th>
                                                    <td>${this.props.invoices.invoiceDetail.oneTimeTotal}</td>
                                                </tr>
                                            </tbody>
                                        </Table>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/invoices/invoicedetails.js